import {
  validateDateComparisonRequired,
  validateYmdListAndStartEndNotDuplicated,
} from '../../utils/apiParamsValidation';
import {
  DataKiSyokenKasidamaSearchParams,
  DataKiSyokenSearchParams,
} from './types';

/**
 * ================================================
 * 機種別商圏画面のAPIリクエスト前のパラメータバリデーション
 * ================================================
 */

/**
 * APIリクエスト前のパラメータバリデーション
 * 機種別商圏のデータを取得する
 * yield call前に呼び出すことで、不正なパラメータでのAPIリクエストを防ぐ
 */
export const validateKiSyokenParams = (
  params: DataKiSyokenSearchParams
): void => {
  // 日付指定の重複チェック
  validateYmdListAndStartEndNotDuplicated(params);

  // 通常の日付フィールドのバリデーション
  validateDateComparisonRequired(params);
};

/**
 * APIリクエスト前のパラメータバリデーション
 * 機種別商圏の貸玉データを取得する
 * yield call前に呼び出すことで、不正なパラメータでのAPIリクエストを防ぐ
 */
export const validateKiSyokenKasidamaParams = (
  params: DataKiSyokenKasidamaSearchParams
): void => {
  // 日付指定の重複チェック
  validateYmdListAndStartEndNotDuplicated(params);

  // 通常の日付フィールドのバリデーション
  validateDateComparisonRequired(params);
};
